import { StandardEvents } from '@shopify/events';

document.addEventListener('click', (event) => {
  const menuLink = event.target.closest?.('.ip-mobile-nav a');
  if (menuLink) menuLink.closest('details').open = false;
});

let cartRevision = 0;

function renderCartCount(count) {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('.ip-cart').forEach((link) => {
    const badge = link.querySelector('[data-cart-count]');
    if (badge) badge.textContent = String(count);
    link.setAttribute('aria-label', `${link.dataset.cartLabel} (${count})`);
  });
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    cartRevision += 1;
    renderCartCount(cart?.totalQuantity ?? detail?.itemCount);
  }).catch(() => {});
});

window.addEventListener('pageshow', async (event) => {
  if (!event.persisted) return;
  const link = document.querySelector('.ip-cart');
  if (!link) return;
  const revision = cartRevision;
  try {
    const response = await fetch(`${link.getAttribute('href')}.json`, {
      headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store',
    });
    if (!response.ok) return;
    const cart = await response.json();
    if (revision === cartRevision) renderCartCount(cart.item_count);
  } catch (_) {
    // Keep the server-rendered count when a history refresh is unavailable.
  }
});
